/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  guard-for-in,
  import/no-extraneous-dependencies,
  no-restricted-syntax,
  no-void,
  react/prop-types
*/
import React from 'react';
import PropTypes from 'prop-types';
import Button from 'common/components/button';
import HfReactHelper from 'common/utils/hf-react-helper';
import SuperAgent from 'superagent';
import createReactClass from 'create-react-class';

require('./template-link-login-or-signup.scss');


const TemplateLinkLoginOrSignup = createReactClass({

  propTypes: {
    shortGuid: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    csrf_token: PropTypes.string.isRequired,
    onSuccess: PropTypes.func,
  },

  getInitialState() {
    return {
      email: '',
      errors: {},
      processing: false,
    };
  },

  onEmailChange(e) {
    this.setState({
      email: e.target.value,
      errors: {
        email: void 0,
      },
    });
  },

  onSubmit(e) {

    e.preventDefault();
    const self = this;

    if (!HfReactHelper.isValidEmailAddress(this.state.email)) {
      this.setState({
        errors: {
          ...this.state.errors,
          email: 'Please enter a valid email address',
        },
      });

      return; // Don't submit bad emails
    }

    this.setState({ processing: true });

    const url = '/signer/getOrCreateAccountForTemplateLink';

    SuperAgent
      .post(url)
      .type('form')
      .send({ email: this.state.email })
      .send({ guid: this.props.shortGuid })
      .send({ csrf_token: this.props.csrf_token })
      .end((err, res) => {
        if (!err) {
          const data = JSON.parse(res.text);
          self.onSuccess(data);
        }
      });
  },

  onSuccess(data) {

    this.setState({ processing: false });

    if (this.props.onSuccess) {
      this.props.onSuccess(data);
    }
  },

  renderErrors() {
    const errors = [];
    for (const error in this.state.errors) {
      errors.push(this.state.errors[error]);
    }

    return errors;
  },

  render() {
    return (
      <div className='m-signer-mobile-template-link--login-or-signup row text-center bg-plume m-create-account--inline-container-vertical l-padding-v-20'>
        <h4>{ this.props.title }</h4>
        <div>To review and sign, enter your email:</div>
        <form id='login-or-signup-form' onSubmit={this.onSubmit}>
          <input
            id='email'
            type='email'
            name='email'
            className='m-signer-mobile-template-link--login-or-signup--email'
            onChange={this.onEmailChange} />
          <Button
            type='submit'
            buttonClass='center'
            buttonText={!this.state.processing ? 'Verify your email address' : 'Sending...'}
            buttonColor='cerulean'
            buttonHoverColor='castle-rock'
            buttonTabIndex='1' />
          <input type='hidden' name='guid' value={this.props.shortGuid} />
        </form>
        <div className='m-signer-mobile-template-link--login-or-signup--error'>
          { this.renderErrors() }
        </div>
        <p className="m-signer-mobile-template-link--login-or-signup--tos">
          By signing up, I accept the HelloSign{' '}
          <a href={this.props.tosUrl} target="_blank" rel="noopener noreferrer">Terms</a> &{' '}
          <a href={this.props.privacyPolicyUrl} target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
        </p>
      </div>);
  },
});

module.exports = TemplateLinkLoginOrSignup;
